import { useRef, useEffect, useCallback } from "react"

export const useInfiniteScroll = (
  callback: () => void,
  hasMore: boolean,
  isLoading: boolean
) => {
  const observerTarget = useRef(null)

  const handleObserver: IntersectionObserverCallback = useCallback(
    (entries) => {
      const target = entries[0]
      if (target.isIntersecting && hasMore && !isLoading) {
        callback()
      }
    },
    [callback, hasMore, isLoading]
  )

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, {
      root: null,
      rootMargin: "200px", // 提前 200px 开始加载，体验更好
      threshold: 0.8,
    })

    if (observerTarget.current) {
      observer.observe(observerTarget.current)
    }

    return () => {
      if (observerTarget.current) {
        observer.unobserve(observerTarget.current)
      }
    }
  }, [handleObserver])

  return observerTarget // 返回 ref，让组件可以绑定到元素上
}
